import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { SectionHeading } from './SectionHeading';
import { beforeItems, afterItems } from '../data/audit';
export function BeforeAfter() {
  return <section className="bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-37" data-mp="3ofhwbbkarfxq">
      <div className="mx-auto w-full max-w-5xl" data-id="element-38" data-mp="3sgl89mz84rto">
        <SectionHeading eyebrow="The real gap" title="The problem isn’t always a lack of knowledge" subtitle="It’s knowing what to review — and in what order." data-id="element-39" data-mp="3sjfsbdebsamk" />

        <div className="mx-auto mt-8 max-w-3xl space-y-2 text-center text-[15px] text-navy-700/80 sm:text-base" data-id="element-40" data-mp="3jihpuzjjcb63">
          <p data-id="element-41" data-mp="39qv80kcozdud">You’ve studied occlusion. You’ve learned about VDO, CR, function and rehabilitation.</p>
          <p data-id="element-42" data-mp="2vr3zv08uwroa">You’ve attended courses. You’ve read books. You’ve accumulated years of clinical experience.</p>
          <p className="pt-2 font-semibold text-navy-900" data-id="element-43" data-mp="30px8ofd77ui4">
            But when a complex patient sits in your chair, having more information
            doesn’t automatically give you a structured review process.
          </p>
        </div>

        <div className="mt-10 grid gap-5 lg:grid-cols-2" data-id="element-44" data-mp="t2fc2753lbmt">
          {/* BEFORE */}
          <div className="overflow-hidden rounded-3xl bg-cream-100 ring-1 ring-navy-900/10" data-id="element-45" data-mp="171osn7x7u7rb">
            <div className="bg-clay px-5 py-4 sm:px-6" data-id="element-46" data-mp="124olsusjl0z5">
              <p className="text-xs font-extrabold uppercase tracking-[0.14em] text-white sm:text-sm" data-id="element-47" data-mp="121txgs6eqw0g">
                Before · Without a system
              </p>
            </div>
            <ul className="space-y-3 p-5 sm:p-6" data-id="element-48" data-mp="9cwioz1enhcg">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-49" data-mp="o56sq387r1jz">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-clay/12 ring-1 ring-clay/25" data-id="element-50" data-mp="jc45ecu14oc8">
                    <XIcon className="h-3.5 w-3.5 text-clay" aria-hidden="true" data-id="element-51" data-mp="3rqvzjr1w9qw9" />
                  </span>
                  <span className="text-[15px] leading-snug text-navy-900/85" data-id="element-52" data-mp="3ms1iounhmces">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* AFTER */}
          <div className="overflow-hidden rounded-3xl bg-navy-900 ring-1 ring-navy-900/10" data-id="element-53" data-mp="20gsuf4hbmcfu">
            <div className="bg-gold-500 px-5 py-4 sm:px-6" data-id="element-54" data-mp="24hw8blft5yef">
              <p className="text-xs font-extrabold uppercase tracking-[0.14em] text-navy-950 sm:text-sm" data-id="element-55" data-mp="24hcofz6lkzxr">
                After · With the Case Audit™
              </p>
            </div>
            <ul className="space-y-3 p-5 sm:p-6" data-id="element-56" data-mp="1crhzw4qkdea5">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-57" data-mp="1grs71kq3eaql">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold-500/20 ring-1 ring-gold-500/40" data-id="element-58" data-mp="1ls63e5ibzw8s">
                    <CheckIcon className="h-3.5 w-3.5 text-gold-300" aria-hidden="true" data-id="element-59" data-mp="2s7gsg7np71pa" />
                  </span>
                  <span className="text-[15px] leading-snug text-cream-100/90" data-id="element-60" data-mp="379f6pxhkjfmu">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 grid max-w-3xl gap-3 sm:grid-cols-2" data-id="element-61" data-mp="2xjduc2ykvlnr">
          <div className="rounded-2xl bg-cream-100 p-5 text-center" data-id="element-62" data-mp="2tiafnjs9nvo4">
            <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-navy-700/60" data-id="element-63" data-mp="2ojz67a5vvn6f">
              Instead of asking
            </p>
            <p className="mt-2 font-display text-lg font-bold italic text-navy-900/70 sm:text-xl" data-id="element-64" data-mp="2jke1ej418kls">
              “What am I forgetting?”
            </p>
          </div>
          <div className="rounded-2xl bg-navy-900 p-5 text-center" data-id="element-65" data-mp="2akziq5u3xebu">
            <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-gold-400" data-id="element-66" data-mp="2amtyz6ufoi9l">
              You can ask
            </p>
            <p className="mt-2 font-display text-lg font-bold italic text-cream-50 sm:text-xl" data-id="element-67" data-mp="8suqsuclyh14">
              “Which area of the audit needs my attention?”
            </p>
          </div>
        </div>

        <div className="mt-10" data-id="element-68" data-mp="kvnpy2it0vn1">
          <CTAButton label="I want the 15-minute Case Audit™" subLabel="Lifetime access · 7-day money-back guarantee" data-id="element-69" data-mp="kuvtyqlaovw8" />
        </div>
      </div>
    </section>;
}